import {connect} from 'react-redux';
import './ReportErrorMessage.scss';
import ReportErrorMessage from './ReportErrorMessage.lazy';
import ValidationUtils from '../../lib/ValidationUtils';
import {retrieveSuburbInsightsAndUpdatePropertyDetail} from 'ducks/propertyDetail';

const mapStateToProps = (state, ownProps) => {
  const { propertyDetail } = state;
  let errorMsgs = ValidationUtils.getReportErrorMessages(state);
  const isLoading = Boolean(propertyDetail.suburbInsights?.isLoading);
  return {
    ...ownProps,
    errorMsgs,
    isLoading,
    propertyDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  const reloadSuburbInsights = (propertyDetail) => {
    const { propertyType } = propertyDetail;
    dispatch(retrieveSuburbInsightsAndUpdatePropertyDetail({ suburbInsights: { isLoading: true } }));
    dispatch(retrieveSuburbInsightsAndUpdatePropertyDetail({ propertyType }));
  };
  return {
    reloadSuburbInsights,
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const ReportErrorMessageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ReportErrorMessage);

export { ReportErrorMessageContainer, ReportErrorMessage };
export default ReportErrorMessageContainer;
